(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Session', Session);


    /* @ngInject */
    function Session($resource) {
        var resourceUrl = 'api/sessions/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getTemplate': {
                url: 'api/sessions/:id?type=TEMPLATE',
                method: 'GET',
            },
            'getSessionSummaryReport': {
                url: 'api/sessions/summary/report',
                method: 'GET',
            },
            'update': {
                method: 'PUT'
            },
            'updateScheduled': {
                url: 'api/sessions/:id?send_invite=true',
                method: 'PUT'
            },
            'invite': {
                url: 'api/sessions/:id/invite',
                method: 'POST'
            },
            'getPersonalRoomSummary': {
                url: 'api/sessions/personal/summary',
                method: 'GET'
            },
            'getPersonalRoomInstances': {
                url: 'api/sessions/personal/instances',
                method: 'GET',
                isArray: true
            },
            'getAnnotationZip': {
                url: 'api/sessions/annotationImages/:id',
                method: 'GET'
            },
            'setOwnerDeviceInfo': {
                url: 'api/sessions/:id/owner/device/info',
                method: 'PUT'
            },
            'getImportStatus': {
                url: 'api/system/job-streams/:id',
                method: 'GET'
            },
            'validatePasscode': {
                url: '/api/sessions/:id/validate-passcode?passcode=:passcode',
                method: 'GET',
                transformResponse: function (data) {
                    return data
                }
            },
            'linkJob': {
                url: 'api/sessions/link/job',
                method: 'POST'
            },
            'unlinkJob': {
                url: 'api/sessions/unlink/job',
                method: 'DELETE'
            },
            'getAISummary': {
                url: 'copilot/api/v1/client/airsession-summary/generate/:id',
                method: 'POST'
            },
            'getSessionTranscriptPDF': {
                url: 'copilot/api/v1/client/airsession-transcript/document/:id',
                method: 'GET'
            }
        });
    }
})();
